import React from 'react';

const STATUS_STYLES = {
  DRAFT:                   { bg: '#F1EFE8', color: '#5F5E5A' },
  GENERATED:               { bg: '#FAEEDA', color: '#633806' },
  SENT:                    { bg: '#E6F1FB', color: '#0C447C' },
  PAID:                    { bg: '#EAF3DE', color: '#27500A' },
  FAILED:                  { bg: '#FCEBEB', color: '#A32D2D' },
  RUNNING:                 { bg: '#E6F1FB', color: '#0C447C' },
  COMPLETED:               { bg: '#EAF3DE', color: '#27500A' },
  COMPLETED_WITH_ERRORS:   { bg: '#FAEEDA', color: '#633806' },
  SKIPPED:                 { bg: '#F3F4F6', color: '#6B7280' },
  MANUAL:                  { bg: '#EDE9FE', color: '#5B21B6' },
  SCHEDULED:               { bg: '#F1F5F9', color: '#475569' },
};

const StatusBadge = ({ status, pulse = false, size = 'sm' }) => {
  const style = STATUS_STYLES[status] || { bg: '#F3F4F6', color: '#6B7280' };
  const sizeClass = size === 'xs' ? 'text-xs px-2 py-0.5' : 'text-xs px-2.5 py-0.5';
  return (
    <span
      className={`inline-flex items-center gap-1 font-semibold rounded-full whitespace-nowrap ${sizeClass}`}
      style={{ backgroundColor: style.bg, color: style.color }}
    >
      {pulse && (
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75"
            style={{ backgroundColor: style.color }} />
          <span className="relative inline-flex rounded-full h-2 w-2"
            style={{ backgroundColor: style.color }} />
        </span>
      )}
      {status?.replace(/_/g, ' ')}
    </span>
  );
};

export default StatusBadge;
